import React, { useState } from 'react';
import {Grid, CustomDropZone, DropZoneHelperText } from 'web-library';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { useDeleteAdminApplicationFile } from '../../../../api-refactored/manage-announcements/useDeleteAdminApplicationFile';
import { useGetAdminApplicationFileConfigs } from '../../../../api-refactored/manage-announcements/useGetAdminApplicationFileConfigs';
import { ApplicationType } from '../../../../api/candidate/config/model';
import AttachedFiles from '../../../../components/upload-documents/AttachedFiles';
import { convertMB2Byte } from '../../../../utils/FileUtils';
import {
  getInitialFiles,
  handleFileDelete,
} from '../../../accessArrangement/SelectCondition/components/UploadDocuments/components/useUploadFile';

interface UploadDocumentsProps {
  files: UploadedFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  isLoading: boolean;
  submittedFiles?: number;
  draftFiles?: UploadedFile[];
  setDraftFiles?: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
}

const UploadOpsAdminDocuments = ({
  files,
  setFiles,
  isLoading,
  submittedFiles,
  draftFiles,
  setDraftFiles,
}: UploadDocumentsProps) => {
  const [dropzoneKey, setDropzoneKey] = useState<string>('');

  const { mutate: deleteFileMutate } = useDeleteAdminApplicationFile();

  const { data: applicationFilesConfig } = useGetAdminApplicationFileConfigs({
    applicationType: ApplicationType.ANNOUNCEMENT,
  });

  const onFileUpload = (uploadedFiles: File[]) => {
    setFiles(
      uploadedFiles.map((file) => ({
        file,
        uploaded: false,
        hasError: false,
        pending: false,
      }))
    );
  };

  const onUploadFileDelete = async (file: File, isDraft = false) => {
    if (isDraft && draftFiles && setDraftFiles) {
      handleFileDelete(file, draftFiles, setDraftFiles, deleteFileMutate);
    } else {
      handleFileDelete(file, files, setFiles, deleteFileMutate);
    }

    setDropzoneKey(Date.now().toString());
  };

  const initialFiles = getInitialFiles(files);

  return (
    <>
      {applicationFilesConfig && (
        <Grid xs={12} sm={12} md={12} lg={12}>
          <CustomDropZone
            filesLimit={applicationFilesConfig.fileNumLimit}
            acceptedFiles={applicationFilesConfig.uploadFileTypes}
            maxSize={convertMB2Byte(applicationFilesConfig.fileSizeLimit)}
            key={dropzoneKey}
            initialFiles={initialFiles}
            onChange={onFileUpload}
            onDelete={onUploadFileDelete}
          />
          <DropZoneHelperText
            acceptedFileTypes={applicationFilesConfig.uploadFileTypes}
            fileLimit={applicationFilesConfig.fileNumLimit}
            fileSizeLimit={applicationFilesConfig.fileSizeLimit}
          />
        </Grid>
      )}
      <AttachedFiles
        isOpsAdmin
        files={files}
        setFiles={setFiles}
        onUploadFileDelete={onUploadFileDelete}
        draftFiles={draftFiles}
        isLoading={isLoading}
        downloadableLink
      />
    </>
  );
};

export default UploadOpsAdminDocuments;
